import React from 'react';

import { Tooltip, IconButton } from '@mui/material';
import { Icon, useSettings, Utils } from 'app/main/components';

export default function ExitToDashboard() {
	const { t } = useSettings();

	return (
		<Tooltip title={t('EXIT_TO_DASHBOARD_BUTTON')} arrow>
			<IconButton
				color="inherit"
				onClick={() => {
					Utils.openLink({ pathname: '/home' });
				}}
			>
				<Icon icon="exit-to-app" />
			</IconButton>
		</Tooltip>
	);
}
